import { useEffect, useRef, useState } from "react";
import logo from "./logo.png";

const MATRIX_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@$%&*#";

function LoginPage({ onLoginSuccess }) {
  const canvasRef = useRef(null);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    let animationFrameId;
    let width = window.innerWidth;
    let height = window.innerHeight;
    const fontSize = 20;
    let columns = Math.floor(width / fontSize);
    let drops = Array(columns).fill(1);

    const resizeCanvas = () => {
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;
      columns = Math.floor(width / fontSize);
      drops = Array(columns).fill(1);
    };

    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);

    const draw = () => {
      ctx.fillStyle = "rgba(0, 0, 0, 0.1)";
      ctx.fillRect(0, 0, width, height);
      ctx.fillStyle = "rgba(48, 219, 91, 0.9)";
      ctx.font = `${fontSize}px monospace`;

      for (let i = 0; i < drops.length; i += 1) {
        const text = MATRIX_CHARS.charAt(
          Math.floor(Math.random() * MATRIX_CHARS.length),
        );
        ctx.fillText(text, i * fontSize, drops[i] * fontSize);
        if (drops[i] * fontSize > height && Math.random() > 0.975) {
          drops[i] = 0;
        }
        drops[i] += 1;
      }

      animationFrameId = requestAnimationFrame(draw);
    };

    draw();

    return () => {
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener("resize", resizeCanvas);
    };
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    setSuccessMessage("");

    if (!username.trim() && !password.trim()) {
      setErrorMessage("Username and password are required.");
      return;
    }

    if (!username.trim()) {
      setErrorMessage("Username is required.");
      return;
    }

    if (!password.trim()) {
      setErrorMessage("Password is required.");
      return;
    }

    if (username !== "neo" || password !== "cybersecure") {
      setErrorMessage("Login failed. Please check your username and password.");
      return;
    }

    setErrorMessage("");
    setSuccessMessage(`Welcome back, ${username}!`);
    if (typeof onLoginSuccess === 'function') {
      onLoginSuccess();
    }
  };

  return (
    <div className="login-page">
      <canvas ref={canvasRef} className="matrix-canvas" />
      <div className="login-fog" />
      <div className="login-shell">
        <div className="login-panel">
          <div className="login-intro">
            <div className="login-brand">
              <img src={logo} alt="logo" className="login-logo" />
            </div>
            <span className="login-eyebrow">SECURE GATEWAY</span>
            <h1>Access the command nexus</h1>
            <p>Authenticate to continue.</p>
          </div>
          <form className="login-form" onSubmit={handleSubmit}>
            <label className="login-label">
              Username
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="login-input"
                placeholder="agent.name"
                autoComplete="username"
              />
            </label>
            <label className="login-label">
              Password
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="login-input"
                placeholder="••••••••"
                autoComplete="current-password"
              />
            </label>
            {errorMessage && <div className="login-error">{errorMessage}</div>}
            {successMessage && (
              <div className="login-success">{successMessage}</div>
            )}
            <button type="submit" className="login-button">
              Unlock
            </button>
          </form>
          <div className="login-note">
            <span>
              Protected Access • Secure Authentication • End-to-End
              Encryption
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
